import { render, staticRenderFns } from "./VersionsSet.vue?vue&type=template&id=d96ff5de&scoped=true"
import script from "./VersionsSet.vue?vue&type=script&lang=js"
export * from "./VersionsSet.vue?vue&type=script&lang=js"
import style0 from "./VersionsSet.vue?vue&type=style&index=0&id=d96ff5de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ff5de",
  null
  
)

export default component.exports